<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="row justify-content-between align-items-center mb-2 zIndexUp">
      <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Company</h4>
      <ul
        class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
        <li *ngIf="permission.Company_Filter==1 || roleId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-info border-info btn " (click)="openClosefun()"><span
              class="mdi mdi-filter"></span>
            Filter</a></li>
        <li *ngIf="permission.Company_Export==1 || roleId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-primary border-primary " (click)="ExportOpenModal(exportConfirm)"><span
              class="mdi mdi-export"></span>
            Export</a></li>
        <li *ngIf="permission.Company_Import==1 || roleId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-danger border-danger" (click)="addDocument.show()"><span
              class="mdi mdi-import"></span>
            Import</a></li>
        <li *ngIf="permission.Company_Add==1 || roleId==1"> <a href="javascript:void(0);"
            routerLink="/company/addcompany" class="btn btn-sm btn-light-info"><span class="mdi mdi-plus"></span>
            Add Company</a></li>
      </ul>
    </div>

    <div class="card mt-3" *ngIf="isCollapsed">
      <div class="card-body">

        <div class="form-row d-flex">
          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Company Name
            </label>
            <angular2-multiselect [settings]="dropdownSetting1" [data]="showname" [(ngModel)]="selectedname"
              (onSelect)="onNameSelect($event)" (onDeSelect)="onNameSelect($event)" (onSelectAll)="onNameSelect($event)"
              (onDeSelectAll)="onNameSelect($event)" fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Company Type</label>
            <angular2-multiselect [settings]="dropdownSetting2" [data]="showtype" [(ngModel)]="selectedtype"
              (onSelect)="onTypeSelect($event)" (onDeSelect)="onTypeSelect($event)" (onSelectAll)="onTypeSelect($event)"
              (onDeSelectAll)="onTypeSelect($event)" fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Business Stream
            </label>
            <angular2-multiselect [settings]="dropdownSettings" [data]="businessStream" [(ngModel)]="selectedBusiness"
              (onSelect)="onBusinessSelect($event)" (onDeSelect)="onBusinessSelect($event)"
              (onSelectAll)="onBusinessSelect($event)" (onDeSelectAll)="onBusinessSelect($event)" fixSearchBug>
            </angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Category
            </label>
            <angular2-multiselect [settings]="dropdownSetting3" [data]="showcategory" [(ngModel)]="selectedcategory"
              (onSelect)="onCategorySelect($event)" (onDeSelect)="OnCategoryDeSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Company Profile
            </label>
            <angular2-multiselect [settings]="dropdownSetting4" [data]="showstatus" [(ngModel)]="selectedprofile"
              (onSelect)="onProfileSelect($event)" (onDeSelect)="OnProfileDeSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="">Country</label>
            <angular2-multiselect [settings]="dropdownCountry" [data]="CountryList" [(ngModel)]="selectedCountry"
              (onSelect)="onCountrySelect($event)" (onDeSelect)="onCountrySelect($event)"
              (onSelectAll)="onCountrySelect($event)" (onDeSelectAll)="onCountrySelect($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">State
            </label>
            <angular2-multiselect [settings]="dropdownSetting7" [data]="stateList" [(ngModel)]="selectedState"
              (onSelect)="onStateSelect($event)" (onDeSelect)="OnStateDeSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">City
            </label>
            <angular2-multiselect [settings]="dropdownSetting8" [data]="cityList" [(ngModel)]="selectedCity"
              (onSelect)="onCitySelect($event)" (onDeSelect)="OnCityDeSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Account Manager
            </label>
            <angular2-multiselect [settings]="dropdownSetting5" [data]="showaccount" [(ngModel)]="selectedaccount"
              (onSelect)="onAccountSelect($event)" (onDeSelect)="OnAccountDeSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2" *ngIf="roleId==1">
            <label for="" class="d-flex align-items-center">Key Account
            </label>
            <angular2-multiselect [settings]="dropdownSettings6" [data]="dropdownList6" [(ngModel)]="selectedItems6"
              (onSelect)="onItemSelect($event)" fixSearchBug>
            </angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Parent Company
            </label>
            <angular2-multiselect [settings]="dropdownSetting6" [data]="showparent" [(ngModel)]="selectedparent"
              (onSelect)="onParentSelect($event)" (onDeSelect)="onParentSelect($event)"
              (onSelectAll)="onParentSelect($event)" (onDeSelectAll)="onParentSelect($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
            <label for="" class="d-flex align-items-center">Status
            </label>
            <angular2-multiselect [settings]="dropdownSettings5" [data]="dropdownList5" [(ngModel)]="selectedItems5"
              (onSelect)="onStatusSelect($event)" (onDeSelect)="onStatusSelect($event)"
              (onSelectAll)="onStatusSelect($event)" (onDeSelectAll)="onStatusSelect($event)"
              fixSearchBug></angular2-multiselect>
          </div>

          <div class="col-xl-2 date-filter-field-3 col-lg-4 col-md-6 mb-3 mb-md-2">
            <label for="" class="d-flex align-items-center">Created Date</label>
            <div class="input-group">
              <div class="w-100">
                <input class="bg-calender-icon form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                  [(ngModel)]="date_range" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                  [settings]="" [showClearButton]="true" placeholder="Select Range"
                  [ngModelOptions]="{standalone: true}" />
                <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                    viewBox="0 0 16 16" (click)="clearEndDate()">
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="col-auto mb-2 mb-md-0">
            <label for="" class="d-none d-md-block">&nbsp;</label>
            <a href="javascript:void(0);" type="submit"
              class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Apply"
              (click)="onSubmit()">
              <i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> Apply</a>
          </div>

          <div class="col-auto mb-2 mb-md-0">
            <label for="" class="d-none d-md-block">&nbsp;</label>
            <a href="javascript:void(0);" class="btn btn-outline-info d-flex align-items-center btn-new-light-info"
              title="Reset" (click)="resetData()">
              <i class="mdi mdi-reload mdi-18px"></i></a>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <!--new naterial table code-->
          <div class="mat-elevation-z8 table-responsive">
            <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
              style="width: 250px !important; float: right;">
              <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword" placeholder="Search"
                (keyup.enter)="applyFilter()" /><span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;" (click)="applyFilter();"></span>
              <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                title="Clear">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                  viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()" (clearEvent)="searchword=''"
                  *ngIf="searchword">
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </mat-form-field>
            <table class="table" mat-table matSorts [dataSource]="dataSource" matSort [matSortActive]="'name'"
              [matSortDisableClear]="true" [matSortDirection]="'asc'" [multiTemplateDataRows]="true"
              (matSortChange)="onSortData($event)" aria-hidden="true">
              <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:105px;">CREATED DATE<img
                    src="assets/images/sort_both.png" *ngIf="columnsort!='CreatedDate'" alt=""><img
                    src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='CreatedDate'"
                    alt=""><img src="assets/images/sort_down.png"
                    *ngIf="downicon && !upicon && columnsort =='CreatedDate'" alt=""></th>
                <td mat-cell *matCellDef="let element">{{element['CreatedDate'] | date: 'dd-MM-yyyy'}}</td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="CompanyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>COMPANY NAME<img src="assets/images/sort_both.png"
                    *ngIf="columnsort!='CompanyName'" alt=""><img src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='CompanyName'"><img src="assets/images/sort_down.png"
                    *ngIf="downicon && !upicon && columnsort =='CompanyName'" alt=""></th>
                <td mat-cell *matCellDef="let element"><a href="javascript:void(0);"
                    (click)="view(element.CompanyId)">{{element['CompanyName']}}</a><br />
                  <small *ngIf="element.Prefix!=''">({{element['Prefix']}})</small>
                </td>
              </ng-container>

              <ng-container matColumnDef="CompanyTypeName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> COMPANY TYPE<img
                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='CompanyTypeName'"><img
                    src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='CompanyTypeName'"><img src="assets/images/sort_down.png"
                    alt="" *ngIf="downicon && !upicon && columnsort =='CompanyTypeName'">
                </th>
                <td mat-cell *matCellDef="let element">{{element['CompanyType']}}</td>
              </ng-container>

              <ng-container matColumnDef="BusinessStreamName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> BUSINESS STREAM<img
                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='BusinessStreamName'"><img
                    src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='BusinessStreamName'"><img
                    src="assets/images/sort_down.png" alt=""
                    *ngIf="downicon && !upicon && columnsort =='BusinessStreamName'">
                </th>
                <td mat-cell *matCellDef="let element"> {{element['BusinessStream']}} </td>
              </ng-container>

              <ng-container matColumnDef="Website">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> WEBSITE <img src="assets/images/sort_both.png"
                    *ngIf="columnsort!='Website'" alt=""><img src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='Website'"><img src="assets/images/sort_down.png" alt=""
                    *ngIf="downicon && !upicon && columnsort =='Website'"></th>
                <td mat-cell *matCellDef="let element"><a target="" href="javascript:void(0);"
                    (click)="AddHttpfun(element.Website)">{{element['Website']}} </a></td>
              </ng-container>

              <ng-container matColumnDef="CompanyProfileName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Profile <img
                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='CompanyProfileName'"><img
                    src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='CompanyProfileName'"><img
                    src="assets/images/sort_down.png" alt=""
                    *ngIf="downicon && !upicon && columnsort =='CompanyProfileName'">
                </th>
                <td mat-cell *matCellDef="let element"> {{element['CompanyProfileName']}} </td>
              </ng-container>

              <ng-container matColumnDef="UserName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Manager <img
                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='UserName'"><img
                    src="assets/images/sort_up.png" alt="" *ngIf="upicon && !downicon && columnsort =='UserName'"><img
                    src="assets/images/sort_down.png" alt="" *ngIf="downicon && !upicon && columnsort =='UserName'">
                </th>
                <td mat-cell *matCellDef="let element"> {{element['UserName']}} </td>
              </ng-container>

              <ng-container matColumnDef="CountryName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> COUNTRY <img src="assets/images/sort_both.png"
                    *ngIf="columnsort!='CountryName'" alt=""><img src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='CountryName'"><img src="assets/images/sort_down.png"
                    *ngIf="downicon && !upicon && columnsort =='CountryName'" alt=""></th>
                <td mat-cell *matCellDef="let element"><span
                    class="badge badge-info text-dark">{{element['CountryName']}}</span></td>
              </ng-container>

              <ng-container matColumnDef="Landline">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> LANDLINE <img src="assets/images/sort_both.png"
                    *ngIf="columnsort!='Landline'" alt=""><img src="assets/images/sort_up.png" alt=""
                    *ngIf="upicon && !downicon && columnsort =='Landline'"><img src="assets/images/sort_down.png"
                    *ngIf="downicon && !upicon && columnsort =='Landline'" alt=""></th>
                <td mat-cell *matCellDef="let element"><span
                    class="badge badge-info text-dark">{{element['Landline']}}</span></td>
              </ng-container>

              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status<img src="assets/images/sort_both.png"
                    *ngIf="columnsort!='Status'" alt=""><img src="assets/images/sort_up.png"
                    *ngIf="upicon && !downicon && columnsort =='Status'" alt=""><img src="assets/images/sort_down.png"
                    *ngIf="downicon && !upicon && columnsort =='Status'" alt=""></th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.StatusName=='Active'" class="badge badge-info text-dark"
                    title="{{element['StatusRemark']}}">
                    {{element['StatusName']}}</span>
                  <span *ngIf="element.StatusName=='Inactive'" class="badge badge-danger text-dark"
                    title="{{element['StatusRemark']}}">{{element['StatusName']}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef><span class="mdi mdi-settings"></span></th>
                <td mat-cell *matCellDef="let element">
                  <div ngbDropdown class="d-block list-dropdown-box">
                    <a href="javascript:void(0);" class="d-block text-center" id="dropdownBasic1" ngbDropdownToggle> <i
                        class="mdi mdi-dots-vertical mdi-24"></i></a>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class=" dropdown-menu-right">
                      <div class="d-block">
                        <a *ngIf="element.StatusName=='Inactive'" class="" placement="bottom" href="javascript:void(0);"
                          title="Active" (click)="openStatusModel(statusConfirm,element.CompanyId,'1',element)"><button
                            ngbDropdownItem><i class="mdi mdi-eye-off"></i>
                            Status</button></a>
                        <a *ngIf="element.StatusName=='Active'" class="" placement="bottom" href="javascript:void(0);"
                          title="Inactive"
                          (click)="openStatusModel(statusConfirm,element.CompanyId,'2',element)"><button
                            ngbDropdownItem><i class="mdi mdi-eye"></i>
                            Status</button></a>
                        <div *ngIf="(permission.Company_Edit==1 || roleId==1) && element.Status!=3">
                          <a href="javascript:void(0);" class="" placement="bottom"
                            (click)="edit(element.CompanyId)"><button ngbDropdownItem><i class="mdi mdi-pencil"></i>
                              Edit</button>
                          </a>
                        </div>
                        <div
                          *ngIf="(permission.Company_Delete==1 || roleId==1) && (element.Status!=3 && element.StatusName!='Delete')">
                          <a href="javascript:void(0);" class="" placement="bottom"
                            (click)="deleteOpenModal(deleteConfirm,element.CompanyName,element.CompanyId)">
                            <button ngbDropdownItem><i class="mdi mdi-delete"></i> Delete</button></a>
                        </div>
                        <div
                          *ngIf="(permission.Company_Restore==1 || roleId==1) && (element.Status==3 && element.StatusName=='Delete')">
                          <a href="javascript:void(0);" class="" placement="bottom"
                            (click)="restoreOpenModal(restoreConfirm,element)">
                            <button ngbDropdownItem><i class="mdi mdi-backup-restore"></i>
                              Restore</button></a>
                        </div>
                        <div
                          *ngIf="(permission.Company_GetDirection==1 || roleId==1) && element.MapLocation!='' && element.Status!=3">
                          <map name="aus-nz">
                            <area shape="poly" coords="3,47,45,12,105,7,140,60,120,125,12,90"
                              href="{{element.MapLocation}}" target="_blank" alt="Australia">
                            <a href="{{element.MapLocation}}" target="_blank" class="" placement="bottom"
                              ngbTooltip="Get Direction">
                              <button ngbDropdownItem><i class="mdi mdi-directions"></i>
                                Get Direction</button></a>
                          </map>
                        </div>
                        <div
                          *ngIf="(permission.Company_SetPrefix==1 || roleId==1) && element.Prefix=='' && element.Status!=3">
                          <a href="javascript:void(0);" class="" placement="bottom"
                            (click)="addDocument3.show();companyname(element)">
                            <button ngbDropdownItem><i class="mdi mdi-stop-circle-outline"></i>
                              Set Prefix</button></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div *ngIf="TotalRecord == 0" class="text-center">
              No Record found.
            </div>
            <div *ngIf="TotalRecord > 0">
              <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize" showFirstLastButtons
                aria-label="Select page of periodic elements" [pageIndex]="currentPage" (page)="handlePage($event)"
                [pageSize]="pageSize">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--View Import modal-->
<div class="modal fade" bsModal #addDocument="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Company Import</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="addDocument.hide(); rtnView();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Upload Document</label>
                <input type="file" id="" class="form-control" (change)="onChange($event)" accept=".xlsx" #inputFile>
              </div>
              <p class="text-info mb-0 mt-1"><a href={{sampleCompanyExl}} download>Download Sample File</a></p>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="import();">Import</button>
        <input #showimport (click)="ImportResult.show()" type="hidden">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
          (click)="addDocument.hide(); rtnView();">Close</a>
      </div>
    </div>
  </div>
</div>

<!--Start Company Import Result modal-->
<div class="modal fade" bsModal #ImportResult="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Company Import Result</h4>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Total Records:
                  <span class="font-weight-bold"> {{Totalrec}} </span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Successful Records:
                  <span class="font-weight-bold">{{valid}}</span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Invalid Records:
                  <span class="font-weight-bold d-inline-block" (click)="openClosefun1()" style="cursor:pointer">
                    {{invalid}}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="form-row animated fadeIn" *ngIf="isCollapsed1">
            <div class="col-lg-12 col-md-12">
              <div class="table-responsive" style="max-height: 300px;">
                <table class="table mb-0" aria-hidden="true">
                  <tbody>
                    <tr *ngFor="let item of dataarray; let i = index">
                      <td>Row {{item.Row}}</td>
                      <td>{{item.Error}} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0);" (click)="ImportResult.hide(); rtnView();" class="btn btn-sm btn btn-info">Ok</a>
      </div>
    </div>
  </div>
</div>
<!-- End Company Import Result modal-->

<!--Set Prefix modal-->
<div class="modal fade" bsModal #addDocument3="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Set Prefix</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="addDocument3.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="editUserForm">
          <div class="form-row animated fadeIn mb-2">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label class="mb-0">Company Name</label>
                <input type="text" id="" class="form-control-plaintext font-weight-bold pt-0" [value]="comname"
                  readonly>
              </div>
            </div>
          </div>
          <div class="form-row animated fadeIn">
            <div class="col-lg-7 col-md-7">
              <div class="form-group mb-0">
                <label>Select Country</label>
                <angular2-multiselect formControlName="CountryId" [data]="CountryList" [(ngModel)]="selectedCountry"
                  [settings]="dropdownCountryPre" (onSelect)="onCountrySelectshort($event)"
                  (change)="countrychange($event)" required>
                </angular2-multiselect>
                <div
                  *ngIf="editUserForm.get('CountryId').invalid && editUserForm.get('CountryId').errors && (editUserForm.get('CountryId').dirty || editUserForm.get('CountryId').touched) || submitted">
                  <small class="text-danger" *ngIf="editUserForm.get('CountryId').hasError('required')">
                    Country is Required.
                  </small>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2">
              <div class="form-group mb-0 mt-4 pt-1">
                <input type="text" readonly class="form-control" formControlName="shortcountry"
                  [value]="shortcountrynam">
              </div>
            </div>
            <div class="col-lg-3 col-md-3">
              <div class="form-group mt-4 pt-1">
                <input [(ngModel)]="Prefix" (ngModelChange)="Prefix = $event.toUpperCase()" placeholder="MAVEN "
                  minlength="5" type="text" formControlName="Prefix" class="form-control" maxlength="5"
                  (input)="NameSpaceNotAllowed($event)" />
                <div
                  *ngIf="editUserForm.get('Prefix').invalid && editUserForm.get('Prefix').errors && (editUserForm.get('Prefix').dirty || editUserForm.get('Prefix').touched) || submitted">
                  <small class="text-danger" *ngIf="editUserForm.get('Prefix').hasError('required')">
                    Prefix is Required.
                  </small>
                  <small class="text-danger" *ngIf="editUserForm.get('Prefix').hasError('pattern')">
                    Prefix must have 5 characters (alphabet and numbers only)
                  </small>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="saveprefix();">Set
          Prefix</button>
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2" (click)="addDocument3.hide()">Close</a>
      </div>
    </div>
  </div>
</div>
<!--Set Prefix modal-->

<!--Export-->
<div class="modal fade" bsModal #addDocument2="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Company Export</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="addDocument2.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Company Creation Date</label>
                <input class="form-control form-control-sm" placeholder="MM/DD/YYYY" type="text" bsDatepicker />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-info">Export</a>
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2" (click)="addDocument2.hide()">Close</a>
      </div>
    </div>
  </div>
</div>

<ng-template #statusConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Company Status Change</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide(); clear()" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Company Name - {{name}}</strong></p>
    <p class="text-left mb-2"><strong>Status - {{CmpStatus}}</strong></p>
    <form [formGroup]="StatusForm">
      <p class="text-left mb-2"><strong>Remark :</strong></p>
      <textarea class="form-control" maxlength="200" formControlName="Remark" (input)="NameSpaceNotAllowed($event)"
        [ngClass]="{ 'is-invalid': submitted1 && StatusForm.get('Remark').errors }"></textarea>
      <div
        *ngIf="StatusForm.get('Remark').invalid && StatusForm.get('Remark').errors && (StatusForm.get('Remark').dirty || StatusForm.get('Remark').touched) || submitted1">
        <small class="text-danger" *ngIf="StatusForm.get('Remark').hasError('required')">
          Remark is Required
        </small>
      </div>
    </form><br>
    <p class="text-left mb-2"> Are you sure you want to change the status ?</p>
  </div>

  <div class="modal-footer">
    <button href="javascript:void(0);" type="submit" class="btn btn-info btn-sm" (click)="makeActiveInactive()"
      [disabled]="delNameDel">Change Status</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide(); clear()">Cancel</button>
  </div>
</ng-template>

<ng-template #exportConfirm>
  <div class="modal-body text-center">
    <p>Do you want to export?</p>
    <button type="button" class="btn btn-info btn-sm" (click)="exportcompany(); modalRef.hide();"
      [disabled]="exportName">Confirm</button>
    <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>
<ng-template #deleteConfirm>
  <div class="modal-body text-center">
    <p>Do you want to delete {{file}}?</p>
    <button type="button" class="btn btn-info btn-sm" (click)="deletecompany(); modalRef.hide();"
      [disabled]="delNameDel">Delete</button>
    <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ng-template #restoreConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Company Restore</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong> C_ID - {{restoreId}}</strong></p>
    <p class="text-left mb-2"><strong>C_Name - {{file}}</strong></p>
    <p class="text-left mb-2">Do you want to restore this Company ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="restorecompany(); modalRef.hide();"
      [disabled]="delNameDel">Restore</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>